export default "__VITE_ASSET__nQO5KMA2__"